import { Component, EventEmitter, Input, Output } from '@angular/core';
import { DocumentFooters } from '@models/businesses';
import { SelectSnapshot } from '@ngxs-labs/select-snapshot';
import { Select } from '@ngxs/store';
import { BusinessState } from '@state/business';
import { CustomTags } from '@state/global/tags/tags.models';
import { TagsSelector } from '@state/global/tags/tags.selector';
import { cloneDeep } from 'lodash';
import { Observable } from 'rxjs';
import { map, take } from 'rxjs/operators';
import { DocumentService } from '../../services/document/document.service';
import { PdfService } from '../../services/pdf/pdf.service';

@Component({
	selector: 'app-html-pdf-viewer',
	templateUrl: './html-pdf-viewer.component.html',
	standalone: false,
})
export class MatterHtmlPdfViewerComponent {
	@Select(TagsSelector.getTagInjectedDocument) parsedDocument$: Observable<
		(doc: string) => string
	>;

	@SelectSnapshot(BusinessState.getFooter) footer: DocumentFooters;
	@SelectSnapshot(TagsSelector.getTags) tags: CustomTags;

	@Output() finishedRendering: EventEmitter<Blob> = new EventEmitter();

	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	@Input() set customStyling(customStyling: any) {
		this._customStyling = cloneDeep(customStyling);
		this.getPdf(this._html, customStyling);
	}

	@Input() set html(html: string) {
		this.getParsedDocument$(html)
			.pipe(take(1))
			.subscribe((result) => {
				this._html = result;
				this.getPdf(result, this._customStyling);
			});
	}

	_html: string;
	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	_customStyling: any;

	documentBlob: Blob;

	constructor(
		private documentService: DocumentService,
		private pdfService: PdfService,
	) {}

	getParsedDocument$(document: string) {
		return this.parsedDocument$.pipe(
			take(1),
			map((_filter) => _filter(document)),
		);
	}

	// rome-ignore lint/suspicious/noExplicitAny: <explanation>
	getPdf(html: string, customStyling: any) {
		void this.pdfService
			.generatePdf(
				cloneDeep(this.documentService.getDefaultDocument()),
				html,
				this.footer,
				'',
				this.tags,
				customStyling ?? null,
			)
			.then((pdf) => {
				this.documentBlob = pdf.blob;
				this.finishedRendering.emit(this.documentBlob);
			});
	}
}
